import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class BranchHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllBranches(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/branch/getAllBranches`);
    }

    getBranchById(branchId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/branch/getBranchById`, { params: { branchId: branchId } });
    }

    newBranch(branch: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/branch/newBranch`, branch);
    }

    editBranch(branch: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/branch/editBranch`, branch);
    }

    deleteBranch(branchId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/branch/deleteBranch`, { params: { branchId: branchId } });
    }

    togglePublishBranch(branchId: any, value: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/branch/togglePublishBranch`,
            {},
            {
                params: { branchId: branchId, value: value },
            }
        );
    }
}
